import { usePage } from "@inertiajs/react";

import Layout from "@/components/Layout";
import { OAuthButtons } from "@/components/OAuthButtons";

interface NewProps {
  oauth_providers: string[];
}

export default function New({ oauth_providers }: NewProps) {
  const { user } = usePage().props;

  return (
    <Layout currentUser={user}>
      <div className="mx-auto max-w-md">
        <div
          data-test-id="sign-in-actions"
          className="card animate-slide-up"
          style={{ animationDelay: "0.1s" }}
        >
          <h1 className="px-font text-px10 text-ink mb-6">Sign in</h1>
          <div className="flex flex-col space-y-2">
            {oauth_providers.map((provider: string) => (
              <div key={provider}>{OAuthButtons[provider]()}</div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
